import endPoints from 'widget/api/endPoints';
import { API } from 'widget/helpers/axios';

const getChatBubbles = (inboxId, lang) => {
  const urlData = endPoints.getChatBubbles(inboxId, lang);

  return API.get(urlData.url);
};

export { getChatBubbles };
